import { call, put, takeLatest } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import swal from 'sweetalert';
import moment from "moment";
import api from 'services/api';

import { Creators as DocumentsActions, Types as DocumentsTypes } from 'store/ducks/documents';

function* getDocumentRequest(action) {
  try {
    const { id } = action.payload;
    const url = `user/v2/document_requests/${id}`;
    const response = yield call(api.get, url);

    yield put(DocumentsActions.getDocumentSuccess(response.data));
  } catch (error) {
    yield put(DocumentsActions.getDocumentFailure());
  }
}

function* getDocumentsRequest(action) {
  try {
    const { page, filters } = action.payload;
    let filter = '';

    if (filters !== null) {
      const store_id = filters.store.value !== '' ? `&store_id=${filters.store.value}` : '';
      const status = filters.status.value !== '' ? `&status=${filters.status.value}` : '';
      const search = filters.search.value !== '' ? `&search=${filters.search.value}` : '';
      const state_id = filters.state.value !== '' ? `&state_id=${filters.state.value}` : '';
      const start_date = filters.start_date !== null ? `&start_date=${moment(filters.start_date).format("YYYY-MM-DD")}` : '';
      const end_date = filters.end_date !== null ? `&end_date=${moment(filters.end_date).format("YYYY-MM-DD")}` : '';

      filter = `${store_id}${status}${search}${state_id}${start_date}${end_date}`;
    }

    const url = `user/v2/document_requests?page=${page}&per=25${filter}`;
    const response = yield call(api.get, url);

    yield put(DocumentsActions.getDocumentsSuccess(response.data));
  } catch (error) {
    yield put(DocumentsActions.getDocumentsFailure());
  }
}

function* getDocumentStoresRequest(action) {
  try {
    const { query } = action.payload;
    const url = `store/v2/places?search=${query}&per=30`;
    const response = yield call(api.get, url);

    yield put(DocumentsActions.getDocumentStoresSuccess(response.data));
  } catch (error) {
    yield put(DocumentsActions.getDocumentStoresFailure());
  }
}

function* approveDocumentRequest(action) {
  try {
    const { id, data, redirect_to } = action.payload;
    const url = `user/v2/document_requests/${id}`;
    const { filters } = data;
    yield call(api.put, url, data);

    yield put(push({
      pathname: redirect_to ? redirect_to : '/documents/list',
      filters,
    }));
    yield call(swal, 'Aprovado', 'Documento aprovado com sucesso!', 'success');
    yield put(DocumentsActions.approveDocumentSuccess());
  } catch (error) {
    yield call(swal, 'Falha ao aprovar', 'Não foi possível aprovar o documento.', 'error');
    yield put(DocumentsActions.approveDocumentFailure());
  }
}

function* repproveDocumentRequest(action) {
  try {
    const { id, data, redirect_to } = action.payload;
    const url = `user/v2/document_requests/${id}`;
    const { filters } = data;
    yield call(api.put, url, data);

    yield put(push({
      pathname: redirect_to ? redirect_to : '/documents/list',
      filters,
    }));
    yield call(swal, 'Reprovado', 'Documento reprovado com sucesso!', 'success');
    yield put(DocumentsActions.repproveDocumentSuccess());
  } catch (error) {
    yield call(swal, 'Falha ao reprovar', 'Não foi possível reprovar o documento.', 'error');
    yield put(DocumentsActions.repproveDocumentFailure());
  }
}

function* getStatesDocumentRequest() {
  try {
    const url = 'user/v2/states?page=1&per=27';
    const response = yield call(api.get, url);

    yield put(DocumentsActions.getStatesDocumentSuccess(response.data));
  } catch (error) {
    yield put(DocumentsActions.getStatesDocumentFailure());
  }
}

export default function* saga() {
  yield takeLatest(DocumentsTypes.GET_REQUEST, getDocumentRequest);
  yield takeLatest(DocumentsTypes.GET_LIST_REQUEST, getDocumentsRequest);
  yield takeLatest(DocumentsTypes.GET_STORES_REQUEST, getDocumentStoresRequest);
  yield takeLatest(DocumentsTypes.APPROVE_REQUEST, approveDocumentRequest);
  yield takeLatest(DocumentsTypes.REPPROVE_REQUEST, repproveDocumentRequest);
  yield takeLatest(DocumentsTypes.GET_STATES_REQUEST, getStatesDocumentRequest);
}
